import { DualListBoxItem } from '../../../../../DualListBox';
import * as S from './Styles';

type AvailableItemMaskProps = FilteredProductItem & {
  availableItems: DualListBoxItem[];
  markedAvailableItems: DualListBoxItem[];
};
const AvailableItemMask = ({ ...product }: AvailableItemMaskProps) => {
  const { ean, resume, code } = product;
  return (
    <S.AvailableItemMaskContainer>
      <S.AvailableItemMaskLabel>
        {`${ean} - ${resume} - ${code}`}
      </S.AvailableItemMaskLabel>
    </S.AvailableItemMaskContainer>
  );
};

export default AvailableItemMask;
